import React, {ChangeEvent} from 'react';

import {Form} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {useField} from 'formik';
import I18nText from '../../i18n/I18nText';
import {CallForPapers, FormWidget, PaperSubmission} from '../../types/types';
import * as yup from "yup";

interface PresentationLanguageSelectWidgetProps {
    widget: FormWidget;
    disabled: boolean;
}

/**
 * Widget zur Auswahl des Themengebiets einer Einreichung.
 */
const PresentationLanguageSelectWidget: React.FC<PresentationLanguageSelectWidgetProps> = ({widget, disabled}) => {

    // W2-605 - Länderkürzel der Sprachen, befinden sich unter src/i18n/languages
    const languages = ['de', 'en', 'pl', 'cn', 'ru', 'cz', 'fr', 'it', 'es'];
    const intl = useIntl();
    const [field, meta, helpers] = useField(`widgets.${widget.id}`);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        helpers.setValue(event.target.value);
    };

    return (
        <Form.Group controlId={field.name}>
            <Form.Label>
                {/*
                    FIXME: die "normalen" Tag-Attribute in die props von I18nText aufnehmen,
                    damit man diese type-safe durchschleusen kann.
                */}
                {/* @ts-ignore */}
                <I18nText className="required" content={widget.label}/>
            </Form.Label>

            <Form.Control as="select"
                          value={field.value}
                          onBlur={field.onBlur}
                          isInvalid={!!(meta.touched && meta.error)}
                          onChange={handleChange}
                          disabled={disabled}
            >
                {languages.map((key) => (
                    <option key={`presentation-language-${key}`} value={key}>
                        {intl.formatMessage({id: `language.${key}`})}
                    </option>
                ))}

            </Form.Control>
            <Form.Control.Feedback type="invalid">
                {meta.error}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export function type() {
    return 'presentation_language_select';
}

export function initialValue(widget: FormWidget) {
    return 'de';
}

export function schema(widget: FormWidget) {
    return yup.string();
}

export function component() {
    return PresentationLanguageSelectWidget;
}

/**
 * liest den Wert aus der Paper Submission aus und gibt ihn zurück
 * Das wird benötigt, um die Form zu initialisieren
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {*}
 */
export function submissionValue(callForPapers:CallForPapers, widget:FormWidget, submission:PaperSubmission) {
    return submission.presentationLanguage
}